import { catchError, map, tap } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { ControlDataForm } from '../../model/control-data/control-data-form';
import { Observable } from 'rxjs';

@Injectable()
export class ControlDataFormService extends DataService<ControlDataForm> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, ControlDataForm, progressBar, 'cd-55');
  }

  OrderPdfPrint(ids: string[]): Observable<File> {
    return this.client.post(`${this.endpoint}/print-to-pdf`, JSON.stringify(ids), { observe: 'response', responseType: 'blob' }).pipe(
      map((res: HttpResponse<Blob>) => {
        return this.toFile(res, 'KU55.pdf');
      }),
      catchError(error => {
        this.notification.showError(error);
        throw new Error();
      }),
      tap(() => this.notification.showSuccess('SUCCESS.HEADER'))
    );
  }

  RegenerateControlData(ids: string[]): Observable<any> {
    return this.client.post<boolean>(`${this.endpoint}/regenerate-control-data`, JSON.stringify(ids)).pipe(
      map((res: boolean) => {
        return res;
      }),
      catchError(error => {
        this.notification.showError(error);
        throw new Error();
      }),
      tap(() => this.notification.showSuccess('SUCCESS.HEADER'))
    );
  }
}
